import { Box, Button, CircularProgress } from '@mui/material'
import { descargarFicheroVenta } from 'api/efacturas/fichero'
import SimpleTable from 'common/components/SimpleTable'
import TableSkeleton from 'common/components/TableSkeleton'
import { formatDateTimeLong, getLocaleDateString } from 'common/libs/fechas'
import { CustomThemeContext } from 'common/providers/CustomThemeProvider'
import { useContext, useEffect, useState } from 'react'
import { CustomerInvoiceHelper } from '../helpers/CustomerInvoiceHelper'

/**
 * The EfacturasVentasList component
 * @component
 *
 * @param {Object} props
 * @param {Array} props.efacturasVentasList
 * @param {boolean} props.loader
 * @returns {JSX.Element}
 */

const EfacturasVentasList = ({ efacturasVentasList, loading }) => {
  const { themeController } = useContext(CustomThemeContext)
  const hideGrupoBalance = themeController?.hide?.EfacturasVentas?.Table?.GrupoBalance

  const [loadingId, setLoadingId] = useState(null)
  const [facturas, setFacturas] = useState([])

  useEffect(() => {
    setFacturas(efacturasVentasList)
  }, [efacturasVentasList])

  const downloadFileHandler = async (event, row) => {
    event.stopPropagation()
    setLoadingId(row.id)

    try {
      const { fichero, nombre_archivo } = await descargarFicheroVenta(row.id)
      const decodedData = atob(fichero)
      const blob = new Blob([decodedData], { type: 'application/xml' })
      const url = window.URL.createObjectURL(blob)
      const downloadLink = document.createElement('a')
      downloadLink.setAttribute('href', url)
      downloadLink.setAttribute('download', nombre_archivo)
      downloadLink.click()
      downloadLink.remove()
      window.URL.revokeObjectURL(url)
    } finally {
      setLoadingId(null)
    }
  }

  return (
    <Box id="efacturas-ventas-list">
      {loading ? (
        <TableSkeleton />
      ) : (
        <SimpleTable
          header_cell_style={{ padding: '5px' }}
          table_style={{ width: '100%', borderCollapse: 'collapse', display: 'table' }}
          container_style={{
            marginBottom: '5px',
            borderRadius: '5px',
            // marginTop: '10px',
          }}
          generic_cell_style={{
            textAlign: 'left',
            padding: '15px 10px',
          }}
          hideHeader={false}
          header_style={{
            textAlign: 'left',
            borderRadius: '5px',
            padding: '10px',
          }}
          stripped={true}
          loading={loading}
          dataSource={facturas}
          fields={[
            {
              field: 'fecha_grabacion',
              title: 'Fecha Grabación',
              customGetter: (item) => {
                return formatDateTimeLong(item.fecha_grabacion)
              },
            },
            ...(!hideGrupoBalance
              ? [
                  {
                    field: 'd_grupo_balance',
                    title: 'Grupo Balance',
                  },
                ]
              : []),
            { field: 'uuid', title: 'Autorización' },
            {
              field: 'fecha_retencion',
              title: 'Fecha Retención',
              customGetter: (item) => {
                return getLocaleDateString(item.fecha_retencion)
              },
            },
            {
              field: 'total_retencion',
              title: 'Total',
            },
            {
              field: 'numero_factura_origen',
              title: 'Nº Factura Origen',
            },
            {
              field: 'nombre_archivo',
              title: 'Nombre Archivo',
            },
            {
              field: 'status',
              title: 'Status',
              customGetter: (item) => {
                return CustomerInvoiceHelper.getStatus(item.status)
              },
            },
            {
              field: 'error_integracion',
              title: 'Error Integración',
            },
            {
              field: 'error_validacion',
              title: 'Error Validación',
            },
            {
              field: 'descargar',
              title: 'Descargar',
              customGetter: (item) => {
                return (
                  <Button
                    onClick={(e) => downloadFileHandler(e, item)}
                    sx={{ padding: '1px 15px' }}
                    disabled={loadingId === item.id}
                  >
                    {loadingId === item.id && (
                      <CircularProgress size={20} sx={{ position: 'absolute' }} />
                    )}
                    descargar
                  </Button>
                )
              },
            },
          ]}
        />
      )}
    </Box>
  )
}

export default EfacturasVentasList
